import { calculateVolumeAndUnits } from '../../../../services/util/volume-and-units.service'

function normalizeLabel(value) {
  return typeof value === 'string' ? value.trim() : ''
}

function roundToTwo(value) {
  return Math.round((Number(value) + Number.EPSILON) * 100) / 100
}

function formatVolumeValue(volume, units) {
  const normalizedVolume = roundToTwo(volume)

  if (normalizedVolume === 0 && units < 0) {
    return '-0'
  }

  return String(normalizedVolume)
}

export function getResumoSeparacaoQuantidadeFracionada(item, quantityField) {
  const { volume, units } = calculateVolumeAndUnits(
    item[quantityField],
    item.unit_sku,
    item.caixa_com_peso_variavel,
  )

  return {
    volume,
    units,
    volumeText: formatVolumeValue(volume, units),
    unitsText: String(units),
    volumeLabel: normalizeLabel(item.un_agregadora) || 'Vol.',
    unitsLabel: normalizeLabel(item.un_fracionada) || 'Frac.',
  }
}
